<template>
  <v-sheet v-if="!workspacePromptsLoading && workspacePrompts.length > 0" class="pa-4" rounded="lg">
    <v-row>
      <v-col>
        <div class="d-flex overflow-x-auto">
          <v-card
            v-for="workspacePrompt in workspacePrompts"
            :key="workspacePrompt.id"
            :class="[
              'ma-2',
              'workspace-prompt-card',
              {'primary-border': workspacePrompt.id === selectedPrompt?.id}
            ]"
            @click.stop="usePrompt(workspacePrompt)"
            elevation="1"
            rounded="lg"
            width="200"
          >
            <div class="d-flex justify-space-between align-start pa-2 btn-container">
              <v-btn
                v-if="!workspaceActionLoading || deleteItemId !== workspacePrompt.id"
                icon
                x-small
                color="primary"
                class="close-btn ml-auto"
                @click.stop="deletePrompt(workspacePrompt.id)"
              >
                <v-icon small>mdi-close</v-icon>
              </v-btn>

              <v-progress-circular
                v-if="workspaceActionLoading && deleteItemId === workspacePrompt.id"
                :size="20"
                :width="2"
                color="primary"
                indeterminate
                class="ml-auto"
              />
            </div>

            <v-card-text class="py-2">
              <div class="prompt-text">{{ workspacePrompt.prompt }}</div>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapGetters: customerGetters } = createNamespacedHelpers('customer');
const { mapGetters: workspacesGetters, mapActions: workspaceActions, mapMutations: workspaceMutations } = createNamespacedHelpers('aiWorkspace');
const { mapGetters: AIChatGetters } = createNamespacedHelpers('AIChat');

import * as moment from "moment";
import lodashGet from "lodash/get";
import Vue from "vue";
import VueLoaders from "vue-loaders";

Vue.use(VueLoaders);

export default {
  name: 'AgentPrompt',
  components: {},
  data() {
    return {
      search: '',
      isCreateDialogOpen: false,
      deleteItemId: null,
    };
  },
  computed: {
    ...customerGetters({
      customer: 'CUSTOMER',
      selectedCustomer: 'SELECTED_CUSTOMER',
      user: 'USER'
    }),
    ...AIChatGetters({
      chatWorkspace: 'GET_CHAT_WORKSPACE',
    }),
    ...workspacesGetters({
      workspacePrompts: 'WORKSPACE_PROMPTS',
      workspacePromptsLoading: 'IS_WORKSPACE_PROMPTS_LOADING',
      workspaceActionLoading: 'IS_WORKSPACE_PROMPTS_ACTION_LOADING',
      selectedPrompt: 'SELECTED_WORKSPACE_PROMPT',
    }),
  },
  watch: {
    'chatWorkspace.id'() {
      if(!this.chatWorkspace?.id) {
        return
      }
      this.getWorkspacePrompts({
        workspaceId: this.chatWorkspace?.id
      })
    }
  },
  methods: {
    ...workspaceActions(['getWorkspacePrompts', 'deleteWorkspacePrompt']),
    ...workspaceMutations({
      setSelectedPrompt: 'SET_SELECTED_WORKSPACE_PROMPT',
      setWorkspacePrompts: 'SET_WORKSPACE_PROMPTS',
    }),
    isShAdmin() {
      return lodashGet(this.customer, 'customer_id') === 0;
    },
    getTime(date) {
      return moment(date).fromNow()
    },
    async deletePrompt(id) {
      this.deleteItemId = id;
      await this.deleteWorkspacePrompt({ workspaceId: this.chatWorkspace?.id, workspacePromptId: id });
      this.setWorkspacePrompts(this.workspacePrompts.filter((prompt) => prompt.id !== id));
      this.deleteItemId = null;
    },
    usePrompt(prompt) {
      if(this.selectedPrompt?.id === prompt?.id) {
        this.setSelectedPrompt(null);
        return;
      }
      this.setSelectedPrompt(prompt);
      this.$emit('onPromptSelect', { prompt: prompt.prompt })
    }
  },
  mounted() {
    if(this.chatWorkspace?.id) {
      this.getWorkspacePrompts({
        workspaceId: this.chatWorkspace.id
      })
    }
  },
  beforeDestroy() {
    this.setSelectedPrompt(null);
  }
};
</script>

<style lang="scss" scoped>
@import './workspace-prompts';
</style>
